import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext({
  currency: "ALL",
  symbol: "L",
  decimals: 0,
  options: {},
  settings: null,
  reload: () => {},
  format: (n) => `${n} L`,
});

const DEFAULT_OPTIONS = {
  ALL: { symbol: "L", name: "Lek Shqiptar", decimals: 0 },
  EUR: { symbol: "€", name: "Euro", decimals: 2 },
  USD: { symbol: "$", name: "Dollar SHBA", decimals: 2 },
  GBP: { symbol: "£", name: "Funt Britanik", decimals: 2 },
  CHF: { symbol: "CHF", name: "Frangë Zvicerane", decimals: 2 },
};

export function CurrencyProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      setSettings({ currency: "ALL", currency_symbol: "L", currency_decimals: 0, currency_options: DEFAULT_OPTIONS });
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const currency = settings?.currency || "ALL";
  const symbol = settings?.currency_symbol || "L";
  const decimals = settings?.currency_decimals ?? 0;
  const options = settings?.currency_options || DEFAULT_OPTIONS;

  const format = useCallback((amount) => {
    const n = Number(amount || 0);
    const formatted = n.toLocaleString("sq-AL", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    // Lek (ALL) typically suffix; €/$/£ prefix
    if (currency === "ALL") return `${formatted} ${symbol}`;
    return `${symbol}${formatted}`;
  }, [currency, symbol, decimals]);

  return (
    <CurrencyContext.Provider value={{ currency, symbol, decimals, options, settings, reload, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
